import { TransferListItem } from 'components/Form/TransferList'
import { PageForAdUnitTransferListDTO } from 'features/inventory/api/types/pageForAdUnitTransferListDTO'
import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { pageForTransferListFromDTO } from './api/mapper'
import { GET_PAGES_FOR_AD_UNIT_TRANSFER_LIST } from './api/query'
import { Data, Variables } from './api/types'
import { UseGetPagesForAdUnitTransferList, UseGetPagesForAdUnitTransferListProps } from './types'

export const useGetPagesForAdUnitTransferList = ({
  domainId,
}: UseGetPagesForAdUnitTransferListProps): UseGetPagesForAdUnitTransferList => {
  const { workspaceId } = useWorkspaceParam()

  const { data, isLoading: loading } = useQuery<Variables, Data, TransferListItem[]>({
    options: {
      enabled: !!domainId,
      select: (data: Data): TransferListItem[] =>
        data.pages.nodes?.map(
          (page: PageForAdUnitTransferListDTO): TransferListItem =>
            pageForTransferListFromDTO(page),
        ) ?? [],
    },
    query: GET_PAGES_FOR_AD_UNIT_TRANSFER_LIST,
    variables: {
      domainId,
      workspaceId,
    },
  })

  const pageAdUnits: TransferListItem[] =
    data?.toSorted((a: TransferListItem, b: TransferListItem): number =>
      a.value.toLowerCase().localeCompare(b.value.toLowerCase()),
    ) ?? []

  return {
    loading,
    pageAdUnits,
  }
}
